import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/logo_dark.png'


const _hoisted_1 = { class: "v-login" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "company_logo"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "company_logo"
}
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "body__body" }
const _hoisted_8 = { class: "body__footer" }

import CommonInput from "@/components/common/CommonInput.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import {useAlert} from "@/utils/alert";
import {ref} from "vue";
import {authService} from "@/features/auth/auth.service";
import {Eye, EyeOff} from "utruckin-icons";
import {useRouter} from "vue-router";
import {setToken} from "@/utils/token";
import {useTheme} from "@/utils/useMode";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const {show} = useAlert();
const router = useRouter();

const email = ref<string>("")
const password = ref<string>("")
const loading = ref<boolean>(false);
const typeInput = ref<"password" | "text">("password");
const {theme} = useTheme();

const login = async () => {
  loading.value = true;
  try {
    const {data} = await authService.login({
      email: email.value,
      password: password.value,
    })
    if (data.access_token) {
      show("Login successful", "success");
      setToken(data.access_token);
      router.push("/message");
    }
  } finally {
    loading.value = false
  }
};

const handleAppendClick = (e: Event) => {
  if (typeInput.value === "password") {
    typeInput.value = "text"

  } else {
    typeInput.value = "password"
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(theme) == 'light')
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "body__header" }, " Sign in ", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(CommonInput, {
            "model-value": email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            label: "Email",
            placeholder: "Email"
          }, null, 8, ["model-value"]),
          _createVNode(CommonInput, {
            type: typeInput.value,
            "model-value": password.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            label: "Password",
            placeholder: "Password",
            "append-icon": typeInput.value == 'text' ? _unref(EyeOff) : _unref(Eye),
            onAppendIconClick: handleAppendClick
          }, null, 8, ["type", "model-value", "append-icon"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(CommonButton, {
            onClick: login,
            type: "primary",
            label: "Sign In"
          })
        ])
      ])
    ])
  ]))
}
}

})